

import { USER_LOG_OUT } from './user';
import { CHECK_PROJECTS_FOR_NOT_FOUND_ITEMS } from './app';

// Actions
const PREFIX = 'calculus/projects/';

export const PROJECT_ADD  = PREFIX + 'PROJECT_ADD';
export const PROJECT_RESTORE  = PREFIX + 'PROJECT_RESTORE';
export const PROJECT_REMOVE  = PREFIX + 'PROJECT_REMOVE';
export const CANCEL_PROJECT_REMOVE  = PREFIX + 'CANCEL_PROJECT_REMOVE';
export const PROJECT_REMOVE_REQUEST  = PREFIX + 'PROJECT_REMOVE_REQUEST';

export const SET_PROJECTS  = PREFIX + 'SET_PROJECTS';
export const UPDATE_PROJECT_TO_PROJECTS  = PREFIX + 'UPDATE_PROJECT_TO_PROJECTS';

const INITIAL_STATE = [

];

// Reducer
export default function reducer(state = INITIAL_STATE, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case PROJECT_ADD:
      return [
        ...state,
        {
          ...payload,
        }
      ];

    case PROJECT_RESTORE:
      return state;

    case CHECK_PROJECTS_FOR_NOT_FOUND_ITEMS:
      if(payload) {
        return [
          ...payload
        ];
      }
      return state;

    case PROJECT_REMOVE:
      if(!payload || payload === undefined) {
        return state;
      }

      const index = state.findIndex((item) => {
        if(item.id === payload.id) {
          return true;
        }
        return false;
      });

      return [
        ...state.slice(0, index),
        ...state.slice(index + 1)
      ];

    case SET_PROJECTS:
      const data = (payload && payload.data && payload.data.data ) ? payload.data.data : [];
      return data.map( item => {
        const actualData = {
          'uuid': item.id,
          ...JSON.parse(item.attributes.data)
        };
        return actualData;
      });

    case UPDATE_PROJECT_TO_PROJECTS:
      return state.map( (item) => {
        if(item.id !== payload.id) {
          return item;
        }
        return payload;
      });

    case USER_LOG_OUT:
      return [];

    default:
      return state;
  }
}

// Action Creators
/*
export function patchProject(payload) {
  return {
    type: PROJECT_ADD,
    payload: payload
  }
}
*/

export function addProject(payload) {
  return {
    type: PROJECT_ADD,
    payload: payload
  };
}

export function removeProject(payload) {
  return {
    type: PROJECT_REMOVE,
    payload: payload
  };
}

export function setProjects(payload) {
  return {
    type: SET_PROJECTS,
    payload: payload
  };
}

export function cancelProjectRemove() {
  return {
    type: CANCEL_PROJECT_REMOVE
  };
}

export function requestProjectRemove() {
  return {
    type: PROJECT_REMOVE_REQUEST
  };
}

export function updateProjectToProjects(payload) {
  return {
    type: UPDATE_PROJECT_TO_PROJECTS,
    payload: payload
  };
}

export function restoreProject(payload) {
  return {
    type: PROJECT_RESTORE,
    payload: payload
  };
}
